// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle the current block state.
   *
   * @object state
   */
  var state = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Set the root block element
      ui.block = dom(".navigation-language");

      // Skip if the block is not present
      if (!ui.block) {
        return;
      }

      ui.button = dom("button", ui.block);
      ui.links = doms("a", ui.block);

      // Handle the aria-expanded state below by watching focus/blur on elements

      ui.button.onfocus = block.expand;
      ui.button.onblur = block.collapse;

      for (var index = 0; index < ui.links.length; index++) {
        ui.links[index].onblur = block.collapse;
      }

    },

    /**
     * Method to handle block expand state.
     *
     * @method block.expand
     */
    expand: function() {

      ui.button.setAttribute("aria-expanded", "true");

    },

    /**
     * Method to handle block collapsed state.
     *
     * @method block.collapse
     */
    collapse: function() {

      // HACK: Remove the timeout workaround
      window.setTimeout(function() {
        if (!ui.block.contains(document.activeElement)) {
          ui.button.setAttribute("aria-expanded", "false");
        }
      }, 10);

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
